/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_AGREEMENT_DETAILS_REQUEST,
  FETCH_AGREEMENT_DETAILS_SUCCESS,
  FETCH_AGREEMENT_DETAILS_FAILURE,
} from "./AgreementDetailsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchAgreementDetailsRequest = () => {
  return {
    type: FETCH_AGREEMENT_DETAILS_REQUEST,
  };
};

export const fetchAgreementDetailsSuccess = (agreementDetails) => {
  return {
    type: FETCH_AGREEMENT_DETAILS_SUCCESS,
    payload: agreementDetails,
  };
};

export const fetchAgreementDetailsFailure = (error) => {
  return {
    type: FETCH_AGREEMENT_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchAgreementDetails = () => {
  return async function (dispatch) {
    dispatch(fetchAgreementDetailsRequest());
    try {
      const data = await APIManager.getCognitoSelf();
      const agreementDetails = data?.results?.[0]?.agreementDetails || null;
      dispatch(fetchAgreementDetailsSuccess(agreementDetails));
    } catch (error) {
      dispatch(fetchAgreementDetailsFailure(error.message));
      dispatch(commonError(error, FETCH_AGREEMENT_DETAILS_FAILURE));
    }
  };
};

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};
